import React, { useState } from 'react';
import { BaseModal } from '@cokitchen/cokitchen-components';
import { ReactComponent as RestoreIcon } from 'assets/icons/blue-add.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import RestoreDeleteRiderFooter from './restore-delete-rider-footer';
import { RiderType } from 'models/rider.model';
import { getUserName } from 'utils/functions';

export type ModalType = 'Restore' | 'Delete';
const RestoreDeleteRiderModal = ({
  show,
  onClose,
  type,
  riders = []
}: {
  show: boolean;
  onClose: () => void;
  type: ModalType;
  riders?: RiderType[];
}) => {
  const [loading] = useState(false);
  const sendDetails = async () => {
    console.log('');
  };

  return (
    <BaseModal
      isOpen={show}
      title={`${type} rider`}
      titleIcon={type === 'Delete' ? <DeleteIcon /> : <RestoreIcon />}
      titleIconColor={type === 'Delete' ? 'danger' : 'info'}
      onRequestClose={onClose}
      footer={
        <RestoreDeleteRiderFooter loading={loading} onCancel={onClose} onConfirm={sendDetails} />
      }>
      <p>
        Are you sure you want to {type === 'Delete' ? 'delete' : 'restore'}
        {riders.length > 1 ? ` these ${riders.length} riders?` : ` ${getUserName(riders[0])}`}
        {type === 'Delete' && ' permanently'}
      </p>
    </BaseModal>
  );
};

export default RestoreDeleteRiderModal;
